import { render, staticRenderFns } from "./BitacoraPantalla.vue?vue&type=template&id=6cc9d58a&"
import script from "./BitacoraPantalla.vue?vue&type=script&lang=ts&"
export * from "./BitacoraPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports